import { UserResponse } from "./types/types";
import { api } from "./instance";
import { User, UserToUpdate } from "@/interfaces/User";

const _userService = {
  getUser: async () => {
    const response = await api.get<UserResponse>(`/user`);
    return response.data;
  },
  allUsers: async () => {
    const response = await api.get<UserResponse[]>(`/user/all`);
    return response.data;
  },
  updateSelf: async (user: Partial<User>): Promise<string> => {
    const response = await api.patch<Partial<User>>(`/user/self`, user);
    return response.statusText;
  },
  createUser: async (user: Partial<User>): Promise<string> => {
    const response = await api.post<Partial<User>>(`/user`, user);
    return response.statusText;
  },
  updateSubscriptions: async (
    user: Partial<UserToUpdate>,
    userId: string,
  ): Promise<string> => {
    const response = await api.patch<Promise<string>>(
      `/user/subs/${userId}`,
      user,
    );
    return response.statusText;
  },
  updateUser: async (user: Partial<User>, userId: string): Promise<string> => {
    const response = await api.patch<Partial<User>>(`/user/id/${userId}`, user);
    return response.statusText;
  },
  deleteUser: async (userId: string): Promise<string> => {
    const response = await api.delete<Partial<User>>(`/user/id/${userId}`);
    return response.statusText;
  },
  restorePassword: async (
    password: string,
    token: string,
  ): Promise<{ message: string }> => {
    const response = await api.post(`/user/restore-password`, {
      password,
      token,
    });
    return response.data;
  },
};

export default _userService;
